(function () {
  var GAL_PER_CUFT = 7.48052;
  var L_PER_GAL = 3.78541;
  var KG_PER_BAG = 10;
  var KG_PER_1000L_PER_1000PPM = 1.3;
  var LB_PER_KG = 2.20462;

  function fmt(n) {
    return Math.round(n).toLocaleString('en-US');
  }

  function num(v) {
    var x = parseFloat(v);
    return isFinite(x) && x > 0 ? x : 0;
  }

  function init(root) {
    if (root.dataset.mgReady) return;
    root.dataset.mgReady = '1';

    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return root.querySelectorAll(sel); };

    var state = { mode: 'know', volume: 12000, shape: 'rect', current: '0', target: '4000' };

    function volumeGallons() {
      if (state.mode === 'know') return state.volume;
      var depth = (num($('[data-in="shallow"]').value) + num($('[data-in="deep"]').value)) / 2;
      if (state.shape === 'round') {
        var r = num($('[data-in="dia"]').value) / 2;
        return Math.PI * r * r * depth * GAL_PER_CUFT;
      }
      var base = num($('[data-in="len"]').value) * num($('[data-in="wid"]').value) * depth * GAL_PER_CUFT;
      return state.shape === 'oval' ? base * 0.893 : base;
    }

    function render() {
      var gallons = volumeGallons();
      var liters = gallons * L_PER_GAL;
      var target = parseFloat(state.target);
      var currentPpm = state.current === 'fresh' ? 0 : parseFloat(state.current) || 0;
      var increase = Math.max(0, target - currentPpm);
      var kg = (liters / 1000) * (increase / 1000) * KG_PER_1000L_PER_1000PPM;
      var bags = kg > 0 ? Math.ceil(kg / KG_PER_BAG) : 0;

      $$('[data-vol-label]').forEach(function (el) { el.textContent = fmt(gallons) + ' gal'; });
      $('[data-target-label]').textContent = fmt(target) + ' ppm';
      $('[data-target-note]').textContent = Number(state.current) > 0
        ? 'Based on the selected target level and your current reading.'
        : 'Assumes a pool starting from zero. Test your water for an accurate figure.';
      $('[data-bags]').textContent = bags;
      $('[data-inc]').textContent = fmt(increase) + ' ppm';
      $('[data-lb]').textContent = (kg * LB_PER_KG).toFixed(1) + ' lb';
      $('[data-gal]').textContent = fmt(gallons) + ' gal';
    }

    function setMode(mode) {
      state.mode = mode;
      $$('[data-mode]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.mode === mode); });
      $('[data-panel="know"]').hidden = mode !== 'know';
      $('[data-panel="calc"]').hidden = mode !== 'calc';
      render();
    }

    function setShape(shape) {
      state.shape = shape;
      var show = shape === 'round' ? ['dia', 'shallow', 'deep'] : ['len', 'wid', 'shallow', 'deep'];
      $$('[data-dim]').forEach(function (l) { l.hidden = show.indexOf(l.dataset.dim) === -1; });
      render();
    }

    $$('[data-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.mode); });
    });
    $('[data-volume]').addEventListener('input', function (e) { state.volume = parseFloat(e.target.value); render(); });
    $('[data-shape]').addEventListener('change', function (e) { setShape(e.target.value); });
    $$('[data-in]').forEach(function (i) { i.addEventListener('input', render); });
    $('[data-current]').addEventListener('change', function (e) { state.current = e.target.value; render(); });
    $('[data-target]').addEventListener('change', function (e) { state.target = e.target.value; render(); });

    var advBtn = $('[data-adv-toggle]');
    var advBody = $('[data-adv]');
    advBtn.addEventListener('click', function () {
      var open = advBtn.getAttribute('aria-expanded') === 'true';
      advBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
      advBody.hidden = open;
    });

    render();
  }

  function run(scope) {
    (scope || document).querySelectorAll('[data-mg-calc]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();

  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
